import { Stack } from "@mui/material";
import { Alert } from "@platform/design-system";

import { RumiReady } from "../RumiReady";

interface Props {
  onRun: () => void;
  /** Why the run failed, when known. */
  reason?: string;
}

/** A failed run: says so and why, then offers the same way to start another. */
const RumiRunFailed = ({ onRun, reason }: Props): React.JSX.Element => (
  <Stack spacing={3} data-testid="rumi-run-failed">
    <Alert severity="error" title="Rumi Failed">
      {reason
        ? `Rumi was unable to complete its analysis: ${reason} Try again.`
        : "Rumi was unable to complete its analysis. Try again."}
    </Alert>
    <RumiReady onRun={onRun} />
  </Stack>
);

export { RumiRunFailed };
export type { Props as RumiRunFailedProps };
